var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-export",
    className: "cls-1",
    d: "M10.64,4.34c0-.18-.07-.34-.19-.46L7.77,1.19c-.13-.13-.3-.2-.46-.19h-.17v3.51h3.51v-.17h0Zm5.12,5.09l-2.62-2.64c-.17-.17-.45-.17-.62,0-.08,.08-.13,.2-.13,.31v1.79h-1.76v1.76h1.76v1.79c0,.25,.2,.44,.44,.43,.12,0,.23-.05,.31-.13l2.62-2.64c.18-.18,.18-.47,0-.66h0Zm-10.39,.78v-.88c0-.25,.2-.44,.44-.44h4.82v-3.5h-3.73c-.37,0-.66-.3-.66-.66V.99H.77C.41,.99,.11,1.29,.11,1.64H.11V14.36c0,.37,.3,.65,.66,.65H9.99c.37,0,.66-.3,.66-.65h0v-3.73H5.82c-.24,0-.43-.2-.43-.43h-.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.b27c1ff80189574bf1a034ec91212b7d.svg";
export { ForwardRef as ReactComponent };